import {
    AboutServiceSectionTabEnum,
    FooterLinkEnum,
    PathEnum,
    ServiceNameEnum,
} from './types/enums';

export const nerdStudioWebsiteLink = 'https://nerd-stud.io/';
export const nerdStudioWebsite = 'nerd-stud.io';

export const MAX_FILES_LENGTH = 10;

export const selectedLocaleLocalStorageKey = 'selectedLocale';

export const notFoundPathName = 'NotFound';

export const services = [
    { name: ServiceNameEnum.LaserCutting, href: PathEnum.LaserCutting },
    { name: ServiceNameEnum.Grinding, href: PathEnum.Grinding },
    { name: ServiceNameEnum.Turning, href: PathEnum.Turning },
    { name: ServiceNameEnum.Milling, href: PathEnum.Milling },
    { name: ServiceNameEnum.WaterJetCutting, href: PathEnum.WaterJetCutting },
    { name: ServiceNameEnum.Welding, href: PathEnum.Welding },
    { name: ServiceNameEnum.Construction3D, href: PathEnum.Construction3D },
    { name: ServiceNameEnum.Bending, href: PathEnum.Bending },
    { name: ServiceNameEnum.Punching, href: PathEnum.Punching },
    { name: ServiceNameEnum.EDM, href: PathEnum.EDM },
];

export const footerLinks = [
    { name: FooterLinkEnum.Returns, href: PathEnum.Returns },
    { name: FooterLinkEnum.FAQ, href: PathEnum.FAQ },
    { name: FooterLinkEnum.About, href: PathEnum.About },
    { name: FooterLinkEnum.Services, href: PathEnum.Services },
];

export const servicesHeroBackgrounds = {
    laserCutting: '/img/services-backgrounds/1.webp',
    grinding: '/img/services-backgrounds/2.webp',
    turning: '/img/services-backgrounds/3.webp',
    milling: '/img/services-backgrounds/4.webp',
    waterJetCutting: '/img/services-backgrounds/5.webp',
    welding: '/img/services-backgrounds/6.webp',
    '3dConstruction': '/img/services-backgrounds/7.webp',
    bending: '/img/services-backgrounds/8.webp',
    punching: '/img/services-backgrounds/9.webp',
    edm: '/img/services-backgrounds/10.webp',
};

export const servicesGalleryPhotos = (t: Function): { imageSrc: string; title: string }[] => [
    { title: t('milling'), imageSrc: '/img/services-backgrounds/4.webp' },
    { title: t('waterJetCutting'), imageSrc: '/img/services-backgrounds/5.webp' },
    { title: t('bending'), imageSrc: '/img/services-backgrounds/8.webp' },
    { title: t('grinding'), imageSrc: '/img/services-backgrounds/11.webp' },
    { title: t('turning'), imageSrc: '/img/services-backgrounds/3.webp' },
    { title: t('punching'), imageSrc: '/img/services-backgrounds/9.webp' },
    { title: t('edm'), imageSrc: '/img/services-backgrounds/10.webp' },
    { title: t('welding'), imageSrc: '/img/services-backgrounds/12.webp' },
    { title: '', imageSrc: '/img/services-backgrounds/14.webp' },
    { title: '', imageSrc: '/img/services-backgrounds/15.webp' },
    { title: '', imageSrc: '/img/services-backgrounds/16.webp' },
    { title: '', imageSrc: '/img/services-backgrounds/17.webp' },
    { title: '', imageSrc: '/img/services-backgrounds/18.webp' },
    { title: t('grinding'), imageSrc: '/img/services-backgrounds/2.webp' },
    { title: '', imageSrc: '/img/services-backgrounds/19.webp' },
    { title: t('3dConstruction'), imageSrc: '/img/services-backgrounds/13.webp' },
];

export const servicesNames = [
    'laser-cutting',
    'grinding',
    'turning',
    'milling',
    'water-jet-cutting',
    'welding',
    '3d-construction',
    'bending',
    'punching',
    'edm',
];

export const aboutServiceTabs = (t: Function) => [
    {
        id: AboutServiceSectionTabEnum.Service,
        label: t('SingleService.tabs.service'),
    },
    {
        id: AboutServiceSectionTabEnum.Process,
        label: t('SingleService.tabs.process'),
    },
    {
        id: AboutServiceSectionTabEnum.Specifications,
        label: t('SingleService.tabs.specifications'),
    },
    {
        id: AboutServiceSectionTabEnum.Utilizations,
        label: t('SingleService.tabs.utilizations'),
    },
];

export const servicesData = (t: Function) => ({
    laserCutting: {
        mediaSrc: '/img/services-backgrounds/1.webp',
        service: {
            title: t('SingleService.laserCutting.service.title'),
            description: t('SingleService.laserCutting.service.description'),
        },
        process: {
            title: t('SingleService.laserCutting.process.title'),
            description: t('SingleService.laserCutting.process.description'),
        },
        specifications: {
            title: t('SingleService.laserCutting.specifications.title'),
            description: t('SingleService.laserCutting.specifications.description'),
        },
        utilizations: {
            title: t('SingleService.laserCutting.utilizations.title'),
            description: t('SingleService.laserCutting.utilizations.description'),
        },
    },
    grinding: {
        mediaSrc: ['/img/services-backgrounds/11.webp', '/img/services-backgrounds/2.webp'],
        service: {
            title: t('SingleService.grinding.service.title'),
            description: t('SingleService.grinding.service.description'),
        },
        process: {
            title: t('SingleService.grinding.process.title'),
            description: t('SingleService.grinding.process.description'),
        },
        specifications: {
            title: t('SingleService.grinding.specifications.title'),
            description: t('SingleService.grinding.specifications.description'),
        },
        utilizations: {
            title: t('SingleService.grinding.utilizations.title'),
            description: t('SingleService.grinding.utilizations.description'),
        },
    },
    turning: {
        mediaSrc: '/img/services-backgrounds/3.webp',
        service: {
            title: t('SingleService.turning.service.title'),
            description: t('SingleService.turning.service.description'),
        },
        process: {
            title: t('SingleService.turning.process.title'),
            description: t('SingleService.turning.process.description'),
        },
        specifications: {
            title: t('SingleService.turning.specifications.title'),
            description: t('SingleService.turning.specifications.description'),
        },
        utilizations: {
            title: t('SingleService.turning.utilizations.title'),
            description: t('SingleService.turning.utilizations.description'),
        },
    },
    milling: {
        mediaSrc: '/img/services-backgrounds/4.webp',
        service: {
            title: t('SingleService.milling.service.title'),
            description: t('SingleService.milling.service.description'),
        },
        process: {
            title: t('SingleService.milling.process.title'),
            description: t('SingleService.milling.process.description'),
        },
        specifications: {
            title: t('SingleService.milling.specifications.title'),
            description: t('SingleService.milling.specifications.description'),
        },
        utilizations: {
            title: t('SingleService.milling.utilizations.title'),
            description: t('SingleService.milling.utilizations.description'),
        },
    },
    waterJetCutting: {
        mediaSrc: '/img/services-backgrounds/5.webp',
        service: {
            title: t('SingleService.waterJetCutting.service.title'),
            description: t('SingleService.waterJetCutting.service.description'),
        },
        process: {
            title: t('SingleService.waterJetCutting.process.title'),
            description: t('SingleService.waterJetCutting.process.description'),
        },
        specifications: {
            title: t('SingleService.waterJetCutting.specifications.title'),
            description: t('SingleService.waterJetCutting.specifications.description'),
        },
        utilizations: {
            title: t('SingleService.waterJetCutting.utilizations.title'),
            description: t('SingleService.waterJetCutting.utilizations.description'),
        },
    },
    welding: {
        mediaSrc: ['/img/services-backgrounds/12.webp', '/img/services-backgrounds/6.webp'],
        service: {
            title: t('SingleService.welding.service.title'),
            description: t('SingleService.welding.service.description'),
        },
        process: {
            title: t('SingleService.welding.process.title'),
            description: t('SingleService.welding.process.description'),
        },
        specifications: {
            title: t('SingleService.welding.specifications.title'),
            description: t('SingleService.welding.specifications.description'),
        },
        utilizations: {
            title: t('SingleService.welding.utilizations.title'),
            description: t('SingleService.welding.utilizations.description'),
        },
    },
    '3dConstruction': {
        mediaSrc: ['/img/services-backgrounds/13.webp', '/img/services-backgrounds/7.webp'],
        service: {
            title: t('SingleService.3dConstruction.service.title'),
            description: t('SingleService.3dConstruction.service.description'),
        },
        process: {
            title: t('SingleService.3dConstruction.process.title'),
            description: t('SingleService.3dConstruction.process.description'),
        },
        specifications: {
            title: t('SingleService.3dConstruction.specifications.title'),
            description: t('SingleService.3dConstruction.specifications.description'),
        },
        utilizations: {
            title: t('SingleService.3dConstruction.utilizations.title'),
            description: t('SingleService.3dConstruction.utilizations.description'),
        },
    },
    bending: {
        mediaSrc: '/video/biegen.webm',
        service: {
            title: t('SingleService.bending.service.title'),
            description: t('SingleService.bending.service.description'),
        },
        process: {
            title: t('SingleService.bending.process.title'),
            description: t('SingleService.bending.process.description'),
        },
        specifications: {
            title: t('SingleService.bending.specifications.title'),
            description: t('SingleService.bending.specifications.description'),
        },
        utilizations: {
            title: t('SingleService.bending.utilizations.title'),
            description: t('SingleService.bending.utilizations.description'),
        },
    },
    punching: {
        mediaSrc: '/video/stanzen.webm',
        service: {
            title: t('SingleService.punching.service.title'),
            description: t('SingleService.punching.service.description'),
        },
        process: {
            title: t('SingleService.punching.process.title'),
            description: t('SingleService.punching.process.description'),
        },
        specifications: {
            title: t('SingleService.punching.specifications.title'),
            description: t('SingleService.punching.specifications.description'),
        },
        utilizations: {
            title: t('SingleService.punching.utilizations.title'),
            description: t('SingleService.punching.utilizations.description'),
        },
    },
    edm: {
        mediaSrc: '/img/services-backgrounds/10.webp',
        service: {
            title: t('SingleService.edm.service.title'),
            description: t('SingleService.edm.service.description'),
        },
        process: {
            title: t('SingleService.edm.process.title'),
            description: t('SingleService.edm.process.description'),
        },
        specifications: {
            title: t('SingleService.edm.specifications.title'),
            description: t('SingleService.edm.specifications.description'),
        },
        utilizations: {
            title: t('SingleService.edm.utilizations.title'),
            description: t('SingleService.edm.utilizations.description'),
        },
    },
});
